import { useCallback, useEffect, useState } from 'react';
import { getNotifications, markNotificationAsRead as markReadService, markAllNotificationsAsRead as markAllReadService, deleteNotification as deleteService } from './mockNotificationsService';
const DEFAULT_PAGE_SIZE = 6;
export function useMockNotifications(options = {}) {
  const {
    limit = DEFAULT_PAGE_SIZE
  } = options;
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    void getNotifications({
      offset: 0,
      limit
    }).then(res => {
      if (!active) return;
      setNotifications(res.notifications);
      setTotalCount(res.totalCount);
      setUnreadCount(res.unreadCount);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [limit]);
  const loadMore = useCallback(() => {
    if (loadingMore) return;
    setLoadingMore(true);
    void getNotifications({
      offset: notifications.length,
      limit
    }).then(res => {
      setNotifications(prev => [...prev, ...res.notifications]);
      setTotalCount(res.totalCount);
      setUnreadCount(res.unreadCount);
      setLoadingMore(false);
    });
  }, [loadingMore, notifications.length, limit]);
  const markAsRead = useCallback(notificationId => {
    setNotifications(prev => prev.map(n => n.notificationId === notificationId ? Object.assign({}, n, {
      isRead: true
    }) : n));
    setUnreadCount(prev => Math.max(0, prev - 1));
    void markReadService({
      notificationId
    });
  }, []);
  const markAllAsRead = useCallback(() => {
    setNotifications(prev => prev.map(n => Object.assign({}, n, {
      isRead: true
    })));
    setUnreadCount(0);
    void markAllReadService();
  }, []);
  const remove = useCallback(notificationId => {
    setNotifications(prev => {
      const target = prev.find(n => n.notificationId === notificationId);
      if (target && !target.isRead) {
        setUnreadCount(u => Math.max(0, u - 1));
      }
      return prev.filter(n => n.notificationId !== notificationId);
    });
    setTotalCount(prev => Math.max(0, prev - 1));
    void deleteService({
      notificationId
    });
  }, []);
  return {
    notifications,
    unreadCount,
    totalCount,
    loading,
    loadingMore,
    hasMore: notifications.length < totalCount,
    loadMore,
    markAsRead,
    markAllAsRead,
    remove
  };
}